import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout for `/categories/$categoryId` and nested subcategory routes. */
export const Route = createFileRoute('/categories_/$categoryId')({
  component: CategoryLayoutRoute,
});

function CategoryLayoutRoute() {
  return <Outlet />;
}
